import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { QueryKey } from '@tanstack/react-query'
import { EmsSgReadyStatus } from 'src/Libs/dynamic-power-prices/types'
import { getSgReadyStatus } from '../api'
import { usePortalQuery } from 'src/Libs/api'

type UseSgReadyStatusQuery = {
  sgReadyStatus: EmsSgReadyStatus | null
  isLoading: boolean
  isError: boolean
}

export const getSgReadyStatusQueryKey = (storageId: string | undefined): QueryKey => ['sgReadyStatus', storageId]

export const useSgReadyStatusQuery = (storageId: string | undefined): UseSgReadyStatusQuery => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: getSgReadyStatusQueryKey(storageId),
    queryFn: () => getSgReadyStatus(storageId, authFetch),
    enabled: Boolean(storageId),
  })

  return {
    sgReadyStatus: data || null,
    isLoading,
    isError,
  }
}
